import React, { useState, useEffect } from 'react';
import { Content, Lesson } from '../../../../../types';
import SectionModule from './section-module/SectionModule';
import { useEditUnit } from '../../edit/useEditUnit';
import {
  Droppable,
  Draggable,
  DraggableProvided,
  DroppableProvided,
  DraggableStateSnapshot
} from 'react-beautiful-dnd';
import { Section } from '@src/api/graphql-codegen';

type Props = {
  contents: Content[];
  lesson?: Lesson;
  section: Section;
};

function SectionModules(props: Props) {
  const { contents, lesson, section } = props;
  const [ localContents, setLocalContents ] = useState<Array<Content>>(contents);
  const { content: selectedContent, section: selectedSection } = useEditUnit();

  useEffect(() => {
    setLocalContents(contents ?? []);
  }, [contents])

  if (!lesson) return null;

  return (
    <Droppable droppableId={`${lesson!.id}_____${section!.id}`} type="droppableSectionModuleItem">
      {(droppableProvided: DroppableProvided) => (
        <div
          ref={droppableProvided.innerRef}
          {...droppableProvided.droppableProps}
        >
          {localContents.length > 0 ?
            localContents.map((item: Content, index: number) => (
              <Draggable
                key={'section' + item.id}
                draggableId={'section' + item.id}
                index={index}
              >
                {(
                  draggableProvided: DraggableProvided,
                  snapshot: DraggableStateSnapshot
                ) => {
                  const sectionSelected = selectedContent?.id === item.id && selectedSection?.id === section.id;
                  return (
                    <div
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                    >
                      <SectionModule draggableProvided={draggableProvided} snapshot={snapshot} lesson={lesson} section={section} key={item.id} selected={sectionSelected} content={item}/>
                    </div>
                  );
                }}
              </Draggable>
            )) :
            <div style={{color:'white', height:'1px'}}>{}</div>}
          {droppableProvided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default SectionModules;
